import { Grid, Box, Typography, withStyles } from "@material-ui/core";
import { ReactNode } from "react";
import { ColorUtils } from "../utils/ColorUtils";

interface OpsPanelProps {
  title?: string;
  icon?: string;
  svg?: string;  // to adapt mui icons size
  actionsRequired?: boolean;
  panelMenu?: ReactNode;
  children: ReactNode;
}

const YellowTextTypography = withStyles({
  root: {
    color: ColorUtils.ENSOLVERS_ORANGE_REBRANDING,
  },
})(Typography);

const OpsPanel: React.FC<OpsPanelProps> = ({ title, icon, svg, actionsRequired, panelMenu, children }) => {

  return (
      <Grid item xs={12} style={{border: `1px solid ${ColorUtils.LIGHTER_GRAY}`, borderRadius: "10px", overflow: "hidden", padding: "1.75em 1.75em", boxShadow: "10px 10px 20px rgb(0, 0, 0, 0.05)" }}>
        <Box display="flex" flexDirection="row" justifyContent="space-between">
          <Box>
            <YellowTextTypography variant="h6" style={{lineHeight: "normal", paddingBottom: "0.75em"}}>
              {icon && <img src={icon} style={{marginRight: "0.5em", marginBottom: "-0.1em"}} alt=""/>}
              {svg && <img src={svg} style={{marginRight: "0.5em", marginBottom: "-0.2em", transform: "scale(1.1)"}} alt=""/>}
              {title}
            </YellowTextTypography>
          </Box>
          {panelMenu}
        </Box>
        {children}
      </Grid>
  );
};

export default OpsPanel;
